import { type SaleProduct } from "../../../Reducers/SellScreen/SellScreenSaleReducerTypes";

export interface ComponentDifference {
    type: "added" | "deleted" | "children";
    name: string;
    icon: "circle" | "minus" | "plus";
    products: Array<ComponentDifference>;
    price: number;
    locked: boolean;
}

export function getComponentDifferences(
    original: Array<SaleProduct>,
    modified: Array<SaleProduct>,
    parentQuantity: number,
    nested = true
): Array<ComponentDifference> {
    const differences: Array<ComponentDifference> = [];

    for(let i = 0, l = original.length; i < l; i++) {
        if(typeof modified[i] === "undefined") {
            differences.push({
                type    : "deleted",
                name    : original[i].name,
                icon    : "minus",
                products: [],
                price   : 0,
                locked  : false,
            });

            continue;
        } else if(modified[i].deleted) {
            differences.push({
                type    : "deleted",
                name    : modified[i].name,
                icon    : "minus",
                products: [],
                price   : modified[i].prices.price * parentQuantity,
                locked  : false,
            });

            continue;
        }

        if(nested) {
            const modifiedDifference = getComponentDifferences(
                original[i].products,
                modified[i].products,
                modified[i].quantity,
                nested
            );

            if(modifiedDifference.length) {
                differences.push({
                    type    : "children",
                    name    : modified[i].name,
                    icon    : "circle",
                    products: modifiedDifference,
                    price   : 0,
                    locked  : modifiedDifference.find(diff => diff.locked)?.locked ?? false,
                });
            }
        }
    }

    if(original.length !== modified.length) {
        for(let i = original.length, l = modified.length; i < l; i++) {
            if(modified[i].initiallyDeleted) {
                differences.push({
                    type    : "deleted",
                    name    : modified[i].name,
                    icon    : "minus",
                    products: [],
                    price   : modified[i].prices.price * parentQuantity,
                    locked  : false,
                });

                continue;
            }

            if(modified[i].deleted) {
                continue;
            }

            differences.push({
                type    : "added",
                name    : modified[i].name,
                icon    : "plus",
                products: [],
                price   : modified[i].prices.price * parentQuantity,
                locked  : modified[i].edited,
            });
        }
    }

    return differences;
}
